import { Component } from '@angular/core';

@Component({
  selector: 'app-call-to-action',
  standalone: false,
  
  templateUrl: './call-to-action.component.html',
  styleUrl: './call-to-action.component.scss'
})
export class CallToActionComponent {

}
